export default {
  TOGGLE: 'TOGGLE_PERMISSIONS_DISPLAY',
  NEW_CONTENT: {
    READERS: {
      ADD: 'ADD_NEW_CONTENT_READER',
      REMOVE: 'REMOVE_NEW_CONTENT_READER'
    },
    WRITERS: {
      ADD: 'ADD_NEW_CONTENT_WRITER',
      REMOVE: 'REMOVE_NEW_CONTENT_WRITER'
    },
    CLEAR: 'CLEAR_NEW_CONTENT_PERMISSIONS',
    SET: 'SET_NEW_CONTENT_PERMISSIONS',
    EXPAND: 'EXPAND_NEW_CONTENT_PERMISSION',
    COLLAPSE: 'COLLAPSE_NEW_CONTENT_PERMISSIONS'
  }
}
